import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useContext } from 'react';
import { useMsal } from '@azure/msal-react';
import LocalizationContext from '../../contexts/LocalizationContext';
import { GRAPH_API_REQUEST } from '../../utils/GraphUtils';
import '../../../css/LoggedOut.css';

var LoggedOut = function LoggedOut() {
  var localizedStrings = useContext(LocalizationContext);

  var _useMsal = useMsal(),
      instance = _useMsal.instance;

  return /*#__PURE__*/React.createElement("div", {
    className: "logged-out-container"
  }, /*#__PURE__*/React.createElement("p", {
    className: "alert alert-warning"
  }, localizedStrings.lorule.logIn.notLoggedIn), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-primary log-in-button",
    onClick: function onClick() {
      instance.loginRedirect(_objectSpread({}, GRAPH_API_REQUEST));
    }
  }, localizedStrings.lorule.logIn.title));
};

export default LoggedOut;